module.exports = __webpack_public_path__ + "static/arrow-7878911ca2bc89bb447c30d64c30dcbc.webm";